import actions from '../../actionTypes';

export default zone => {
  return {
    type: actions.EDIT_ZONE,
    zone
  };
};



// WEBPACK FOOTER //
// ./src/reducers/zones/actions/editZone.js